import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export type Domain = {
    name: string;
    price: string;
    renewal: string;
    status: string;
    duration: string;
    authCode?: string;
    hosting?: string;
};

export type CartType = {
    send_invoice: boolean;
    domains: Array<Domain>;
    addDomain: (domain: Domain) => void;
    removeDomain: (domain: Domain) => void;
    addAuthCode: (domain: Domain, authCode: string | undefined) => void;
    addHosting: (domain: Domain, hosting: string) => void;
    removeHosting: (domain: Domain) => void;
    voucher?: string;
    setVoucher: (voucher: string) => void;
    setSendInvoice: (send_invoice: boolean) => void;
    clear: () => void;
};

export const useCart = create<CartType>()(
    persist(
        (set) => ({
            domains: [],
            send_invoice: false,
            addDomain: (domain) => {
                set((state) => {
                    const domains = state.domains;
                    if (!domains.map((d) => d.name).includes(domain.name)) {
                        domains.push(domain);
                    }
                    return { domains: domains };
                });
            },
            removeDomain: (domain) => {
                set((state) => {
                    const domains = state.domains;
                    const index = domains.findIndex((value) => {
                        return value.name === domain.name;
                    });
                    if (index >= 0) {
                        domains.splice(index, 1);
                    }
                    return { domains: domains };
                });
            },
            addAuthCode: (domain, authCode) => {
                set((state) => {
                    const domains = state.domains;
                    const index = domains.findIndex((value) => {
                        return value.name === domain.name;
                    });
                    if (index >= 0) {
                        domains[index].authCode = authCode;
                    }
                    return { domains: domains };
                });
            },
            addHosting: (domain, hosting) => {
                set((state) => {
                    const domains = state.domains;
                    const index = domains.findIndex((value) => {
                        return value.name === domain.name;
                    });
                    if (index >= 0) {
                        domains[index].hosting = hosting;
                    }
                    return { domains: domains };
                });
            },
            removeHosting: (domain) => {
                set((state) => {
                    const domains = state.domains;
                    const index = domains.findIndex((value) => {
                        return value.name === domain.name;
                    });
                    if (index >= 0) {
                        domains[index].hosting = undefined;
                    }
                    return { domains: domains };
                });
            },
            voucher: undefined,
            setVoucher: (voucher) => {
                set({ voucher: voucher });
            },
            setSendInvoice: (send_invoice) => {
                set({ send_invoice: send_invoice });
            },
            clear: () => {
                set({ domains: [], voucher: undefined });
            },
        }),
        {
            name: `at.reg.cart`,
            storage: createJSONStorage(() => localStorage),
        }
    )
);
